<template>
  <transition name="fade">
    <div id="cover" v-show="coverVisible">
      <h1>{{ introWord }}</h1>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'cover',
  data() {
      return {
          coverVisible: true,
          intro: "Hello. My name is Jun Ichiro Koyama. I am a designer slash developer who creates web products, currently focusing on Fashion- tech. I wish you all a lovely day. Stay safe but don't forget to have fun.",
          // intro: "This is test.",
          introArr: null,
          introWord: '',
          day: 'day'
      }
  },
  methods: {
    introToArr() {
      // Replace day with the actual day
      this.intro = this.intro.replace("day", this.day);
      // Convert into to Array
      this.introArr = this.intro.split(/[ ]+/)
    },
    toIntroWord() {
      const it = this.introArr[Symbol.iterator]();
      const int = setInterval(() => { // time interval
        const next = it.next(); // next value 
        if (!next.done) { // done = true when the end of array reached
          this.introWord = next.value; // concatenate word to the string
        } else {
          this.coverVisible = false
        }
      }, 240) // interval duration
    },
    getDay() {
      var now = new Date();
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      this.day = days[ now.getDay() ];
    }
  },
  created() {
    // Get day
    this.getDay()
    // INTRO WORD FLASH
    this.introToArr()
    setTimeout(this.toIntroWord,1000);
  }
}
</script>

<style scoped lang="scss">
  #cover {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: $primary;
    color: $wallpaper;
    @include flex(center, center, 0, 0, 1);
    z-index: 1000;
  }

  h1 {
    margin-bottom: var(--space-md);
  }

  p {
    display: contents;
  }
</style>